'use strict';
const angular = require('angular');

export default angular.module('conduuApp.weather', [])
  .directive('weather', function($timeout) {
    return {
      template: '<div id="weather"></div>',
      restrict: 'EA',
      scope: {
        location: "@",
        unit: "@"
      },
      link: function (scope, element, attrs) {

        var unit = scope.unit || "f";

        $timeout(function () {

          /*
           Docs at http://simpleweatherjs.com
           */

          $(document).ready(function () {
            $.simpleWeather({
              location: scope.location,
              woeid: '',
              unit: unit,
              success: function (weather) {
                var html = '<h2><i class="icon-' + weather.code + '"></i> ' + weather.temp + '&deg;' + weather.units.temp + '</h2>'
                  + weather.currently + ' &middot; ' + weather.wind.direction + ' ' + weather.wind.speed + ' ' + weather.units.speed;

                $("#weather").html(html);
              },
              error: function (error) {
                $("#weather").html('No data available!');
              }
            });
          });

        });

      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/weather/weather.directive.js